import { Component, Inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CrusherDataPreview, CsvNewColumnInfo } from 'src/app/bo/crusher-data.models';

@Component({
  selector: 'app-preview-dialog',
  templateUrl: './preview-dialog.component.html',
  styleUrls: ['./preview-dialog.component.scss'],
  standalone: false
})
export class PreviewDialogComponent {
  readonly newColumnCount = signal(0);
  readonly dateRange = signal<{ from: string; to: string } | null>(null);

  constructor(
    public dialogRef: MatDialogRef<PreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CrusherDataPreview
  ) {
    this.newColumnCount.set(data.newColumns.length);
    this.computeDateRange();
  }

  private computeDateRange(): void {
    const dateCol = this.data.csvColumns.find(c => c.toLowerCase() === 'report_date');
    if (!dateCol || !this.data.previewRows?.length) return;

    const dates = this.data.previewRows
      .map(r => r[dateCol])
      .filter((d): d is string => !!d)
      .sort();

    if (dates.length > 0) {
      this.dateRange.set({ from: dates[0], to: dates[dates.length - 1] });
    }
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
